import { withUnmountTransition } from '../../../misc/withUnmountTransition.hoc'
import { ManualPrescriptionBottomPanel } from './ManualPrescriptionBottomPanel.component'

const withUnmountHoc = withUnmountTransition(ManualPrescriptionBottomPanel)
export { withUnmountHoc as ManualPrescriptionBottomPanel }
